import { render, staticRenderFns } from "./ErrorLogs.vue?vue&type=template&id=bc817bf2&scoped=true"
import script from "./ErrorLogs.vue?vue&type=script&lang=js"
export * from "./ErrorLogs.vue?vue&type=script&lang=js"
import style0 from "./ErrorLogs.vue?vue&type=style&index=0&id=bc817bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc817bf2",
  null
  
)

export default component.exports